// extracted by mini-css-extract-plugin
module.exports = {"logo":"Nav_logo___ztWv"};